// index

let dt_references = null;

export function index(){

    let providers = JSON.parse($('#providers_data').val());

    let columns = [];
    columns.push({ width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },);
    columns.push({ width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_reference_actions });
    columns.push({ width: '100', data: 'ean', orderable: true, searchable: true });
    columns.push({ data: 'name', orderable: true, searchable: true });
    columns.push({ width: '160', data: 'clients_names', orderable: false, searchable: false, class: 'text-nowrap', defaultContent: '', render: render_clients_names });
    for(let i = 0; i < providers.length; i++){
        columns.push({ width: '80', data: `provider_${providers[i].id}_offer`, orderable: false, searchable: false, class: 'text-right', render: render_provider_offer(providers[i]), defaultContent: '' });
    }
    columns.push({ width: '55', data: 'purchases[0].price', orderable: true, searchable: false, class: 'text-right', render: datatables.render_price });
    columns.push({ width: '45', data: 'purchases[0].date', orderable: true, searchable: false, class: 'text-right', render: datatables.render_date });
    columns.push({ width: '55', data: 'sales[0].price', orderable: true, searchable: false, class: 'text-right', render: datatables.render_price });
    columns.push({ width: '45', data: 'sales[0].date', orderable: true, searchable: false, class: 'text-right', render: datatables.render_date });
    columns.push({ width: '45', data: 'stock', orderable: false, searchable: false, defaultContent: '', class: 'text-right', render: render_stock });
    columns.push({ width: '60', data: 'units_per_box', orderable: false, searchable: false, defaultContent: '', class: 'text-right', render: render_stock });
    columns.push({ width: '60', data: 'boxes_per_pallet', orderable: false, searchable: false, defaultContent: '', class: 'text-right', render: render_stock });
    columns.push({ width: '55', data: 'best_price', orderable: false, searchable: false, defaultContent: '', render: datatables.render_price });
    columns.push({ width: '55', data: 'benefit', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: datatables.render_price });
    columns.push({ width: '55', data: 'margin', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: datatables.render_percentage });
    columns.push({ width: '80', data: 'best_provider_name', orderable: false, searchable: false, class: 'text-nowrap', defaultContent: '', render: render_best_providers_name });
    columns.push({ width: '45', data: 'best_provider_stock', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_stock});
    columns.push({ width: '60', data: 'best_provider_units_per_box', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_units_per_box});
    columns.push({ width: '60', data: 'best_provider_units_per_pallet', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_units_per_pallet});
    columns.push({ width: '60', data: 'best_provider_boxes_per_pallet', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_boxes_per_pallet});
    columns.push({ width: '60', data: 'best_provider_min_order', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_min_order});
    columns.push({ width: '60', data: 'best_provider_max_order', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_max_order});
    columns.push({ width: '60', data: 'best_provider_expiration', orderable: false, searchable: false, class: 'text-nowrap', defaultContent: '', render: render_best_providers_expiration});
    columns.push({ width: '50', data: 'best_provider_language', orderable: false, searchable: false, class: 'text-nowrap', defaultContent: '', render: render_best_providers_language});
    columns.push({ width: '80', data: 'best_provider_category', orderable: false, searchable: false, class: 'text-nowrap', defaultContent: '', render: render_best_providers_category});

    dt_references = $('#references_table').DataTable({
        ajax: {
            url: $('#references_table').attr('url'),
            type: 'POST',
        },
        responsive: false,
        columns: columns,
        select: {
            style: 'multi',
            selector: 'td:first-child'
        },
        order: [[3, 'asc']],
        pageLength: 25,
        lengthMenu: [25, 50, 100, 200, 500],
        dom: "<'row'<'col-sm-12 d-flex flex-column flex-sm-row justify-content-between align-items-center filters-container'l<'filters'f>>><'row'<'col-sm-12 overflow-x-scroll'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
    });

    // Batch actions event handlers
    dt_references.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="add_categories"]').click(batch_add_categories);
        $(settings.nTableWrapper).find('.table_batch_actions [action="remove_categories"]').click(batch_remove_categories);
    });

    dt_references.on('draw', function(e, settings){
        $('#references_table span.best_provider_offer').closest('td').addClass('bg-success-light');
    });

}

function render_reference_actions(data, type, row){
    const url_info = $("#references_table").attr('url_info') ?? '';
    if(url_info === '') return '';
    
    const info_url = url_info.replace('#', row.id);
    
    const actions = 
    '<div class="btn-group" role="group">' +
    '   <a class="btn btn-primary btn-xs show ajax" href="' + info_url + '">' + window.__('info') + '</a>' +
    '</div>';
    
    return actions;
}

function batch_add_categories(){
    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    
    let references_id = [];
    $.each(rows_selected, function(index, rowId){
        references_id.push(rowId);
    });

    console.log(table, table.column(0), rows_selected, references_id, references_id.join(','));
    
    if(references_id.length == 0){
        window.messages.error(__('No has seleccionado ninguna referencia'));
    } else {
        $('#add-categories-modal input[name="reference_ids"]').val(references_id.join(','));
        $('#add-categories-modal select[name="category_ids[]"]').val(null).trigger('change');
        $('#add-categories-modal').modal('show');
    }
}

function batch_remove_categories(){
    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    
    let references_id = [];
    $.each(rows_selected, function(index, rowId){
        references_id.push(rowId);
    });
    
    if(references_id.length == 0){
        window.messages.error(__('No has seleccionado ninguna referencia'));
    } else {
        $('#remove-categories-modal input[name="reference_ids"]').val(references_id.join(','));
        $('#remove-categories-modal select[name="category_ids[]"]').val(null).trigger('change');
        $('#remove-categories-modal').modal('show');
    }
}

export function updated_categories_reload(){
    $('#add-categories-modal').modal('hide');
    $('#remove-categories-modal').modal('hide');
    dt_references.ajax.reload();
}

function render_stock(data, type, row){

    if(
        data === null 
        || data === undefined
    ){
        return '-';
    }

    return new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(data);

}

function render_clients_names(data, type, row){

    if(
        row.clients_names === undefined
        || row.clients_names.length === 0
    ){
        return '-';
    }

    return row.clients_names.map(function(name){
        return name != null && name != '' ? name : '-';
    }).join('<br>');

}

function render_best_providers_name(data, type, row){

    if(
        row.best_providers_name === undefined
        || row.best_providers_name.length === 0
    ){
        return '-';
    }

    return row.best_providers_name.map(function(name){
        return name != null && name != '' ? name : '-';
    }).join('<br>');

}

function render_best_providers_stock(data, type, row){

    if(
        row.best_providers_stock === undefined
        || row.best_providers_stock.length === 0
    ){
        return '-';
    }

    return row.best_providers_stock.map(function(stock){
        return stock != null && stock != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(stock) : '-';
    }).join('<br>');

}

function render_best_providers_units_per_box(data, type, row){

    if(
        row.best_providers_units_per_box === undefined
        || row.best_providers_units_per_box.length === 0
    ){
        return '-';
    }

    return row.best_providers_units_per_box.map(function(units){
        return units != null && units != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(units) : '-';
    }).join('<br>');

}

function render_best_providers_units_per_pallet(data, type, row){

    if(
        row.best_providers_units_per_pallet === undefined
        || row.best_providers_units_per_pallet.length === 0
    ){
        return '-';
    }

    return row.best_providers_units_per_pallet.map(function(units){
        return units != null && units != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(units) : '-';
    }).join('<br>');

}

function render_best_providers_boxes_per_pallet(data, type, row){

    if(
        row.best_providers_boxes_per_pallet === undefined
        || row.best_providers_boxes_per_pallet.length === 0
    ){
        return '-';
    }

    return row.best_providers_boxes_per_pallet.map(function(boxes){
        return boxes != null && boxes != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(boxes) : '-';
    }).join('<br>');

}

function render_best_providers_min_order(data, type, row){

    if(
        row.best_providers_min_order === undefined
        || row.best_providers_min_order.length === 0
    ){
        return '-';
    }

    return row.best_providers_min_order.map(function(units){
        return units != null && units != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(units) : '-';
    }).join('<br>');

}

function render_best_providers_max_order(data, type, row){

    if(
        row.best_providers_max_order === undefined
        || row.best_providers_max_order.length === 0
    ){
        return '-';
    }

    return row.best_providers_max_order.map(function(units){
        return units != null && units != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(units) : '-';
    }).join('<br>');

}

function render_best_providers_expiration(data, type, row){

    if(
        row.best_providers_expiration === undefined
        || row.best_providers_expiration.length === 0
    ){
        return '-';
    }

    return row.best_providers_expiration.map(function(expiration){
        return expiration != null && expiration != '' ? expiration : '-';
    }).join('<br>');

}

function render_best_providers_language(data, type, row){

    if(
        row.best_providers_language === undefined
        || row.best_providers_language.length === 0
    ){
        return '-';
    }

    return row.best_providers_language.map(function(language){
        return language != null && language != '' ? language : '-';
    }).join('<br>');

}

function render_best_providers_category(data, type, row){

    if(
        row.best_providers_category === undefined
        || row.best_providers_category.length === 0
    ){
        return '-';
    }

    return row.best_providers_category.map(function(category){
        return category != null && category != '' ? category : '-';
    }).join('<br>');

}

let render_provider_offer = function(provider){
    return function(data, type, row){

        if(
            row.best_providers_id === undefined
            || row.best_providers_id.length === 0
            || data === null
            || data === ''
        ){
            return '-';
        }

        data = new Intl.NumberFormat(window._locale, {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
            useGrouping: true
        }).format(data);

        if(row.best_providers_id.includes(provider.id)){
            return `<span class="best_provider_offer">${data}</span>`;
        }

        return data;

    }
}
